import React, { useState } from "react";
import { Form, Input, Select, Button, message } from "antd";
import PlaceSearch from "./PlaceSearch";
import { controller } from "../controller";
import { addressLine } from "../lib/placeToAddress";

const { Option } = Select;

// Practice.address is a 256-character column.
const PRACTICE_ADDRESS_MAX = 256;

// "Basic Information" step of the multi-office path (the practice; each office
// gets its own UpdateOffice step). The address search comes FIRST and fills the
// fields below it from the selected Google place; they stay editable so a
// partial parse can be fixed. This form used to drop the street address
// entirely (the search callback ignored it and the submit never sent one).
const UpdatePractice = (props) => {
  const [form] = Form.useForm();
  const [lat, setLat] = useState("-1");
  const [long, setLong] = useState("-1");
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    // The practice serializer names the postal code `zipcode`.
    const { zip_code, ...rest } = values;
    const myData = {
      ...rest,
      zipcode: zip_code,
      latitude: lat,
      longitude: long,
    };
    const response = await controller.updatePractice(myData, props.practiceId);
    if (response.status < 250) {
      props.readOnboardingStatus();
      message.success("Practice information updated!");
    } else {
      message.error(response.detail);
    }
    setLoading(false);
  };

  const onAddress = (a) => {
    if (a.latitude != null) setLat(String(a.latitude));
    if (a.longitude != null) setLong(String(a.longitude));
    form.setFieldsValue({
      address: addressLine(a, PRACTICE_ADDRESS_MAX),
      city: a.city,
      state: a.state,
      zip_code: a.postal_code,
      ...(a.country ? { country: a.country } : {}),
    });
  };

  return (
    <>
      <p style={{ fontSize: "20px", fontWeight: "500", marginBottom: 37 }}>Basic Information of your Practice</p>

      <Form form={form} name="updatePracticeForm" onFinish={onFinish} autoComplete="off">
        <div className="form-container">
          <div className="form-item full-width">
            <div className="input-lable">Find your practice address</div>
            <PlaceSearch onAddress={onAddress} placeholder="Start typing your practice address…" />
            <div style={{ fontSize: 12, color: "#888", marginTop: 6 }}>
              Pick your address from the list and we'll fill in the rest — check it below before submitting.
            </div>
          </div>

          <div className="form-item full-width">
            <div className="input-lable">Street address</div>
            <Form.Item name="address" rules={[{ required: true, message: "Please enter the street address!" }]}>
              <Input placeholder="Street address" maxLength={PRACTICE_ADDRESS_MAX} />
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">Country</div>
            <Form.Item
              name="country"
              rules={[
                { required: true, message: "Please select a country!" },
                {
                  validator: (_, value) =>
                    ["Canada", "United States of America"].includes(value) ? Promise.resolve() : Promise.reject("Invalid country"),
                },
              ]}
            >
              <Select placeholder="Select a country" style={{ height: 39 }}>
                <Option value="Canada">Canada</Option>
                <Option value="United States of America">United States of America</Option>
              </Select>
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">State / Province</div>
            <Form.Item name="state" rules={[{ required: true, message: "Please enter the state!" }]}>
              <Input placeholder="Enter state" />
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">City</div>
            <Form.Item name="city" rules={[{ required: true, message: "Please enter the city!" }]}>
              <Input placeholder="Enter city" />
            </Form.Item>
          </div>

          <div className="form-item">
            <div className="input-lable">Postal Code</div>
            <Form.Item name="zip_code" rules={[{ required: true, message: "Please enter the postal code!" }]}>
              <Input placeholder="Enter postal code" />
            </Form.Item>
          </div>

          <div className="form-item full-width">
            <Form.Item>
              <Button loading={loading} style={{ marginTop: "25px", width: "100%", height: 39 }} type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};

export default UpdatePractice;
